/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import GetchkdUsersList from '../views/getchkdUser/GetchkdUsersList';
import GetchkdUserCreation from '../views/getchkdUser/GetchkdUserCreation';

const ManageGetchkdUsersPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage GetChkd Users'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />
                    <Grid item xs={12} sm={6} md={6} >

                        <GetchkdUserCreation />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <GetchkdUsersList />
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default ManageGetchkdUsersPage;